import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'lyceo-ui-more-menu-item',
  templateUrl: './more-menu-item.component.html',
  styleUrls: ['./more-menu-item.component.scss'],
  imports: [RouterLink, RouterLinkActive, FontAwesomeModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreMenuItemComponent {
  public link: InputSignal<undefined | string[]> = input();
  public externalLink: InputSignal<boolean> = input(false);

  protected readonly faChevronRight: IconDefinition = faChevronRight;
}
